<template>
  <v-container class="service-ticket-view">
   <v-row>
     <v-col
       cols="12"
       sm="8"
       class="pa-0 ticket-section"
     >
       <div class="title-section d-flex subtitle-1 font-weight-medium">
         <v-icon class="mr-2 mt-1 align-baseline" color="#41CE65">mdi-ticket-confirmation</v-icon>
         <div class="word-break text-ellipsis">{{ item.subject }}</div>
       </div>
       <v-row class="ml-9">
         <v-col clos="12" class="px-0 py-1">
           <a 
             @click="onDescription(item)"
             target="_blank"
             v-track="'view-description'"
             class="caption text-decoration-none"
           >
             <span class="">View Description</span>
             <v-icon color="info" small> mdi-open-in-app </v-icon>
           </a>
         </v-col>
         <v-col clos="12" class="px-0 py-1">
           <label class="caption">Agent Name:</label>
           <span class="pl-2 body-2">{{ item.agent_name !== ' ' ? item.agent_name : '--' }}</span>
         </v-col>
       </v-row>
       <v-row class="ml-9">
         <v-col class="pa-0">
           <label class="caption">Ticket Type:</label>
           <span class="pl-2 body-2">{{ item.ticket_type_name ? item.ticket_type_name : '--' | upperCaseFirst}}</span>
         </v-col>
         <v-col class="pa-0">
           <label class="caption">Priority:</label>
           <span class="pl-2 body-2">
             <v-icon size="21" :color="constants.PRIORITY_COLORS[item.priority]">
               {{`mdi-alpha-${item.priority[0]}-circle`}}
             </v-icon>
             {{ item.priority |upperCaseFirst }}</span>
         </v-col>
       </v-row>
     </v-col>
     <v-col class="text-right pa-0" cols="12" sm="4">
         <p class="body-2">{{ $options.filters.formatDateTZ(item.created_at) }}</p>
     </v-col>
     <v-col
       cols="12"
       class="d-flex pl-9 pt-0 pr-0 pb-1"
     >
     <div class="mt-4 mr-auto">
       <v-chip
         outlined
         small
         :color="constants.TICKET_STATUS[item.status] ? constants.TICKET_STATUS[item.status].color : 'grey'"
       >
         {{ constants.TICKET_STATUS[item.status].name }}
       </v-chip>
     </div>
     <div>
       <v-btn
         outlined
         small
         class = "mt-2 ml-4 font-weight-bold"
         @click="onRedirect(item)"
         v-track="'redirect-to-ticket-page'"
       >
         View
       </v-btn>
     </div>
     </v-col>
   </v-row>
   <v-dialog
     v-model="showDescription"
     width="800"
   >
     <v-card>
       <v-card color="#FFFFFF" flat>
         <div>
           <div class="pt-6 mb-0 d-flex align-center justify-center ">
            <div class=" d-flex float-left pl-8">
             <span class="grey--text text--darken-2 body-2 font-weight-regular d-flex align-center">From :  </span>
             <div v-if="ticketDetails.contact_email">
               <div
                 class="d-flex flex-row text-capitalize ml-2"
               >
               <div class="font-weight-regular" v-if="contactSortName" >
                 <span class="body-1"> {{ ticketDetails.contact_name }} </span>
                   <span class="body-2"> ({{ ticketDetails.contact_email }}) </span>
               </div>
                 <div v-else>
                   {{ ticketDetails.contact_email }}
                 </div>
               </div>
             </div>
             <div v-else class="d-flex flex-row text-capitalize">
                <span v-if="contactSortName">
                  {{ ticketDetails.contact_name }}
                </span>
                <span v-else>
                  {{ ticketDetails.contact_email }}
                </span>
             </div>
            </div>
            <div class="float-left body-2 grey--text text--darken-2 pl-2 font-weight-regular">
              reported via
              <span v-if="ticketDetails.channel">
                {{ ticketDetails.channel.replace("_", " ") | upperCaseFirst }}
              </span>
              {{ $options.filters.formatDateTZ(ticketDetails.created_at) }}
            </div>
            <v-spacer></v-spacer>
          </div>
          <v-row
            no-gutters
            v-if="ticketDetails.to_emails"
            class="px-8 pb-2 mt-2"
          >
            <template v-if="ticketDetails.to_emails.length">
              <v-col class="grey--text text--darken-2 body-2 font-weight-regular" cols="auto"> To : </v-col>
              <v-col
                cols="auto"
                class="black--text text--darken-2 pl-1 body-2 font-weight-regular"
              >
                <div v-if="Array.isArray(ticketDetails.to_emails)">
                  <span
                    v-for="(
                      email, index
                    ) in ticketDetails.to_emails"
                    :key="index"
                  >
                    <span v-if="index >= 1" :key="index">,</span>
                    {{ email }}
                  </span>
                </div>
                <div v-else>
                  {{ ticketDetails.to_emails }}
                </div>
              </v-col>
            </template>
            <template
              v-if="
                ticketDetails.cc_emails &&
                ticketDetails.cc_emails.length
              "
            >
              <v-col cols="auto" class="pl-1"> Cc: </v-col>
              <v-col
                cols="auto"
                class="grey--text text--darken-2 pl-1"
              >
                <span
                  v-for="(email, index) in ticketDetails.cc_emails"
                  :key="index"
                  >{{ email }}
                </span>
              </v-col>
            </template>
          </v-row>
        </div>
        <v-divider />
        <v-card-text class="px-8 description-box">
         <span class="black--text font-weight-600 secondary--font text-h5-heading">
           {{ ticketDetails.subject }}
         </span>
          <p
            class="py-5 body-1 black--text mb-8"
            v-html="ticketDetails.description"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
         <v-spacer></v-spacer>
         <v-btn dark @click="showDescription=false" class="font-weight-large mr-3 my-3"
          v-track="'confirm-close-ticket-action'">
           Close
         </v-btn>
       </v-card-actions>
      </v-card>
    </v-card>
   </v-dialog>
 </v-container>
</template>
<script>
import { mapGetters } from "vuex"
import constants from '@core/config/constants'

export default {
 name: "contact-ticket",
 props: {
   item: {
     type: Object,
     default: () => ({})
   }
 },
 data() {
     return {
       constants: constants,
       showDescription: false,
       ticketDetails: {}
     };
 },
 computed: {
   ...mapGetters({
     account: 'auth/account.current',
   }),
   contactSortName() {
     let shortName = "";
     if (this.ticketDetails.contact_name) {
       let name = this.ticketDetails.contact_name.split(" ");
       if (name.length >= 2) {
         shortName = name[0].charAt(0) + name[1].charAt(0);
       } else {
         shortName = name[0].charAt(0);
       }
     }
     return shortName;
   },
 },
 methods: {
   onRedirect (item) {
     if (process.env.VUE_APP_PRODUCT == 'Service') {
       this.$router.push({ name: 'ticket-details', params: { id: item.id } })
     } else {
       window.open(`/service/${this.account.id}/tickets/${item.id}`, '_blank');
     }
   },
   onDescription (item) {
     this.showDescription = true
     this.ticketDetails = item
   }
 },
};
</script>
<style scoped>
.description-box{
 max-height: 400px; 
 overflow-y: scroll;
}
</style>
